export default __webpack_public_path__ + "static/media/YouTube.f54b3d3a.svg";